import { createAsyncThunk } from '@reduxjs/toolkit';

import { getRegionId } from '@/packages/Filters/shared/utils/geo';
import { type TJsonQuery } from '@/packages/JsonQuery';

import { type IRegionalDistrictModel } from '@/repositories/generated/shared/geo/entities/RegionalDistricts/RegionalDistrictModel';

import { fetchRegionalDistricts } from '@/microfrontends/filters/shared/services/fetchRegionalDistricts';
import { type IGeoTagsMap } from '@/microfrontends/filters/shared/types/geoTags';

import { type TThunkApi } from '../../types';

interface IOpenResult {
  districts: IRegionalDistrictModel[];
  jsonQuery: TJsonQuery;
  geoTags: IGeoTagsMap;
}

export const open = createAsyncThunk<IOpenResult, undefined, TThunkApi>(
  'regionalDistrictsPopup/open',
  async (_, thunkApi) => {
    const { extra, getState } = thunkApi;

    const state = getState();

    const jsonQuery = state.jsonQuery.current;
    const geoTags = state.geoTags.data;
    const locationId = getRegionId(state.location.data);

    const regionalDistrictsResult = await fetchRegionalDistricts(extra, { locationId });
    const districts = regionalDistrictsResult.map(result => result.districts).unwrapOr([]);

    return {
      districts,
      jsonQuery,
      geoTags,
    };
  },
  {
    condition: (_, thunkApi) => {
      const state = thunkApi.getState();

      return state.regionalDistrictsPopup.status !== 'loading';
    },
  },
);
